import apiClient from './client';
import type { User, UpdateUserInput } from '@/types/user';

/**
 * Fetches the current user's profile from the backend.
 * @returns The current user's data.
 */
export async function fetchCurrentUser(): Promise<User> {
  const response = await apiClient.get<User>('/api/auth/current-user');
  return response.data;
}

/**
 * Updates the current user's profile on the backend.
 * @param profileData Partial object containing user fields to update.
 * @returns The updated user data.
 */
export async function updateUserProfile(profileData: Partial<UpdateUserInput>): Promise<User> {
  const response = await apiClient.put<User>('/api/users/me', profileData);
  return response.data;
}
